module.exports = __webpack_public_path__ + "img/pi-2-4-3.b086f86c.jpg";